<div class="modal-body ml-3 mr-2">
  <app-day-parting-inputs
    [strategy$]="modalData.strategy$!"
    [locale]="modalData.locale"
    [saveButtonPresent]="true"
    [placeholderPause]="modalData.dayPartingPauseHour"
    [placeholderReactivation]="modalData.dayPartingReactivationHour"
    [placeholderSwitch]="true"
    #dayPartingInputsComponent
  ></app-day-parting-inputs>
</div>
<div class="modal-footer" *transloco="let t">
  <IButton color="white" [label]="t('common.close')" (onClick)="modalRef.close()" />

  <IButton type="submit" [label]="t('common.save')" (onClick)="onSave()" />
</div>
